<template>
  <ul :class="$style.breadcrumbList" v-if="items.length > 0">
    <li
      :class="$style.breadcrumbList__item"
      v-for="(link, index) in items"
      :key="index"
    >
      <icon-angle v-if="index > 0" :class="$style.breadcrumbList__separator" />
      <RouterLink
        v-if="isInternalLinkType(link)"
        :class="$style.breadcrumbList__link"
        :to="link.to"
      >
        {{ link.text }}
      </RouterLink>
      <a v-if="isSamePageLinkType(link)" :class="$style.breadcrumbList__link">
        {{ link.text }}
      </a>
    </li>
  </ul>
</template>

<script lang="ts">
import type { PropType } from 'vue'
import { defineComponent } from 'vue'
import IconAngle from '@/components/icons/IconAngle.vue'
import type {
  BreadCrumbLink,
  InternalLinkType,
  SamePageLinkType,
} from '@/types/app'
import { isInternalLinkType, isSamePageLinkType } from '@/libs/utilities/link'

export default defineComponent({
  name: 'BreadcrumbList',
  components: {
    IconAngle,
  },
  props: {
    links: {
      type: Array as PropType<ReadonlyArray<BreadCrumbLink>>,
      default: () => [],
    },
  },
  computed: {
    items(): BreadCrumbLink[] {
      return this.links.length > 0
        ? [{ to: { name: 'dashboard' }, text: 'HOME' }, ...this.links]
        : []
    },
  },
  methods: {
    isInternalLinkType(value: BreadCrumbLink): value is InternalLinkType {
      return isInternalLinkType(value)
    },
    isSamePageLinkType(value: BreadCrumbLink): value is SamePageLinkType {
      return isSamePageLinkType(value)
    },
  },
})
</script>

<style lang="scss" module>
.breadcrumbList {
  display: flex;
  align-items: center;
  margin-left: -8px;
  font-size: 12px;

  &__separator {
    font-size: 10px;
  }

  &__item {
    display: flex;
    align-items: center;
    color: $color-text-and-object-medium-emphasis;

    &:last-child {
      font-weight: bold;
    }
  }

  &__link {
    padding: 4px 8px;
    color: $color-text-and-object-medium-emphasis;

    &:hover {
      color: $color-text-and-object-accent-primary;
    }
  }
}
</style>
